enum ACTION_STRINGS {
    SET_GLOBAL_VARIABLES = "[GLOBAL VARIABLES] SET",
    REPLACE_GLOBAL_VARIABLES = "[GLOBAL VARIABLES] REPLACE",
    ADD_GLOBAL_VARIABLES = "[GLOBAL VARIABLES] ADD",

    RESET_ERROR = "[GLOBAL VARIABLES] RESET ERROR",
}

export default ACTION_STRINGS;